import { useEffect } from 'react';
import { createPortal } from 'react-dom';

/**
 * Janela sobreposta da especificação. Padrão: modal no centro (computador) e
 * folha que sobe de baixo (celular). `lado`: gaveta pela direita (a cesta).
 * ESC ou clique fora fecham; o fundo não rola enquanto está aberta.
 */
export default function Folha({ titulo, subtitulo, onFechar, children, rodape, largura = 520, lado = false, className = '' }) {
  useEffect(() => {
    const onKey = e => { if (e.key === 'Escape') onFechar?.(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', onKey); document.body.style.overflow = prev; };
  }, [onFechar]);

  return createPortal(
    <div className={`folha-fundo ${lado ? 'lado' : ''}`} onMouseDown={e => { if (e.target === e.currentTarget) onFechar?.(); }}>
      <div className={`folha ${lado ? 'folha-lado' : ''} ${className}`} style={{ '--folha-largura': `${largura}px` }} role="dialog" aria-modal="true">
        <div className="folha-topo">
          <div className="folha-topo-txt">
            {typeof titulo === 'string' ? <div className="folha-titulo">{titulo}</div> : titulo}
            {subtitulo && <div className="folha-sub">{subtitulo}</div>}
          </div>
          <button type="button" className="folha-x" onClick={onFechar} aria-label="Fechar"><i className="bi bi-x-lg" /></button>
        </div>
        <div className="folha-corpo">{children}</div>
        {rodape && <div className="folha-rodape">{rodape}</div>}
      </div>
    </div>,
    document.body,
  );
}
